export default "__VITE_ASSET__CeOsxkfW__"